<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนงาน
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              1.แผนการดำเนินงานวิจัย (จัดทำในรูปเเบบ Project based management)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
                theme="6"
                :disabled="partOneEditMode"
                @onClick="addNewPlan"
            >
              + เพิ่มแผนดำเนินงาน
            </Button>
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 hide-scroll">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 42px; max-width: 42px">
                จัดการ
              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 61px; max-width: 61px">
                WF
              </div>
              <div
                  v-for="(m, ind) in shortMonths"
                  :key="ind"
                  class="flex"
                  style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div class="flex text-center" style="min-width: 43px; max-width: 43px">
                %
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div v-if="allPlans && allPlans.length > 0" class="d-flex flex-column gap-12">
              <div
                  v-for="(item, i) in allPlans"
                  :key="i"
                  class="plan-card d-flex justify-space-between gap-8"
                  :class="{ 'plan-active': partOneEditMode && (tempPlan && tempPlan.temp_index === i) }"
              >
                <div class="flex" style="min-width: 42px; max-width: 42px">
                  <v-btn small icon @click="editPlan(i)">
                    <Iconify
                        icon="material-symbols:edit"
                        color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <div class="flex two-line" style="min-width: 120px; max-width: 120px; max-height: 45px">
                  {{ item.p1_activity_name }}
                </div>
                <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px; height: 54px">
                  <v-divider vertical></v-divider>
                  <div class="tiny-field tf-active" style="min-width: 40px; max-width: 40px; height: 100%">
                    {{ item.p1_wf }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                    v-for="(m, ind) in item.project_section_plan_month"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                >
                  {{ m.month_value ? m.month_value : '-' }}
                </div>
                <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                  -
                </div>
                <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                  {{ item.percent }}
                </div>
              </div>

              <!--   SUMMARY   -->
              <div class="plan-card">
                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 42px; max-width: 42px">

                  </div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนงานถ่วงน้ำหนัก
                  </div>
                  <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px">
                    <v-divider vertical></v-divider>
                    <div class="tiny-field" :class="{ 'theme-color-four tf-error': totalWF() !== '1.00' }" style="min-width: 40px; max-width: 40px">
                      {{ totalWF() }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div>

                  <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex tiny-field"
                      style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(ind) }}
                  </div>

                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 42px; max-width: 42px">

                  </div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    ผลการดำเนินงาน
                  </div>
                  <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px">
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px">
                    </div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex tiny-field"
                      style="min-width: 43px; max-width: 43px"
                  >
                    -
                  </div>
                  <div class="flex" style="min-width: 43px; max-width: 43px">

                  </div>
                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 42px; max-width: 42px">

                  </div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    การใช้จ่ายจริง
                  </div>
                  <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px">
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px">
                    </div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex tiny-field"
                      style="min-width: 43px; max-width: 43px"
                  >
                    -
                  </div>
                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                </div>

              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>

          </div>
        </div>

      </div>

      <div v-if="partOneEditMode" id="part-one-edit" class="card-part">
        <div class="d-flex gap-16 mb-3">
          <div>
            <div class="black--text mb-3">
              กิจกรรม
            </div>

            <TextField
                theme="3"
                :value="tempPlan.p1_activity_name"
                @onChange="tempPlan.p1_actvity_name = $event"
            ></TextField>
          </div>
          <div>
            <div class="black--text mb-3">
              WF
            </div>

            <TextField
                theme="3"
                input-type="decimal"
                :value="tempPlan.p1_wf"
                :error="error_p1_wf"
                @onChange="tempPlan.p1_wf = $event"
            ></TextField>
          </div>
        </div>

        <div class="plan-field-form">
          <div
              v-for="(month, i) in shortMonths"
              :key="i"
          >
            <div class="text-center mb-2">{{ month.month }} {{ month.year }}</div>
            <TextField
                theme="3"
                input-type="decimal"
                :error="tempPlan.project_section_plan_month[i]?.error || tempPlan.project_section_plan_month[i]?.errorSkipInput"
                :value="tempPlan.project_section_plan_month[i]?.month_value"
                @onChange="tempPlan.project_section_plan_month[i].month_value = $event"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button
              min-width="80px"
              theme="2"
              @onClick="partOneEditMode = false"
          >ยกเลิก
          </Button>

          <Button
              min-width="80px"
              theme="6"
              @onClick="savePlan"
          >ยืนยัน
          </Button>
        </div>

      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div class="mb-5">
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              2. งบประมาณ (รายละเอียดการประเมินค่าใช้จ่ายในโครงการ)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
                theme="6"
                :disabled="partTwoEditMode"
                @onClick="addNewBudget"
            >
              + เพิ่มรายละเอียดงบประมาณ
            </Button>
          </div>

          <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
            <div style="width: 8%">จัดการ</div>
            <div style="width: 10%">รายการ</div>
            <div style="width: 22%">รายละเอียด</div>
            <div class="text-end" style="width: 15%">สนับสนุนโดยภาคเอกชน<br>In-kind</div>
            <div class="text-end" style="width: 15%">สนับสนุนโดยภาคเอกชน<br>In-cash</div>
            <div class="text-end" style="width: 15%">สนับสนุนโดย<br>อุทยานวิทยาศาสตร์</div>
            <div class="text-end" style="width: 15%">รวม</div>
          </div>

          <div class="d-flex flex-column gap-16">
            <div
                v-for="(item, i) in budgetList"
                :key="i"
                class="budget-item"
            >
              <div class="d-flex black--text gap-12">
                <div style="width: 8%">
                  <v-btn small icon>
                    <Iconify
                        icon="material-symbols:edit"
                        color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <div style="width: 10%">{{ item.budget_name }}</div>
                <div
                    style="width: 25%"
                    v-html="item.budget_detail?.replace(/\n/g, '<br>')"
                ></div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_in_kind, 2) }}
                </div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_in_cash, 2) }}
                </div>
                <div class="text-end" style="width: 19%">
                  {{ formatNumber(item.budget_sci_park, 2) }}
                </div>
                <div class="text-end" style="width: 18%">
                  {{ formatNumber(item.budget_sum, 2) }}
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-if="budgetList && budgetList.length > 0" class="d-flex flex-column gap-12 px-12 mb-5">
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมลำดับที่ 1-{{ budgetList.length }}</div>
            <div class="theme-color-one">{{ formatNumber(budgetList.map(x => x.budget_sum).reduce((a, b) => parseFloat(a) + parseFloat(b), 0), 2) }} บาท</div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมงบสนับสนุนโดยภาคเอกชน เป็นเงิน</div>
            <div class="theme-color-one">{{ formatNumber(budgetList.map(x => (parseFloat(x.budget_in_kind) + parseFloat(x.budget_in_cash))).reduce((a, b) => a + b, 0), 2) }} บาท</div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมงบสนับสนุนโดยอุทยานวิทยาศาสตร์ เป็นเงิน</div>
            <div class="theme-color-one">{{ formatNumber(budgetList.map(x => parseFloat(x.budget_sci_park)).reduce((a, b) => a + b, 0), 2) }} บาท</div>
          </div>
<!--          <div class="d-flex justify-space-between">-->
<!--            <div class="black&#45;&#45;text">รวมค่าใช้จ่ายสุทธิ</div>-->
<!--            <div class="theme-color-one">{{ formatNumber(budgetList.map(x => x.budget_sum).reduce((a, b) => a + b, 0), 2) }} บาท</div>-->
<!--          </div>-->
        </div>

        <div class="remark-box">
          หมายเหตุ :
          <div>* ค่าตอบแทนของคณะทำงาน ไม่เกินร้อยละ 30 ของงบประมาณโครงการทั้งหมด</div>
          <div>* ทรัพยากรที่จำเป็น (In-kind) ไม่เกินร้อยละ 50 ของงบประมาณ (In-cash) ที่ภาคเอกชนสนับสนุน</div>
          <div>* ภาคเอกชนต้องออก (In-kind + In-cash) อย่างน้อยร้อยละ 50 หรือมากกว่าร้อยละ 50 ของยอดเงิน
            งบประมาณทั้งหมด
          </div>
        </div>
      </div>

      <div v-if="partTwoEditMode" id="part-two-edit" class="card-part">
        <div class="d-flex gap-16 mb-3"  style="align-items: end">
          <div>
            <div class="black--text mb-3">
              รายการ
            </div>

            <TextField
                theme="3"
                :value="tempBudget.budget_name"
                @onChange="tempBudget.budget_name = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
              สนับสนุนโดยภาคเอกชน<br>
              In-kind
            </div>

            <TextField
                theme="3"
                input-type="decimal"
                :value="tempBudget.budget_in_kind"
                @onChange="tempBudget.budget_in_kind = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
              สนับสนุนโดยภาคเอกชน<br>
              In-cash
            </div>

            <TextField
                theme="3"
                input-type="decimal"
                :value="tempBudget.budget_in_cash"
                @onChange="tempBudget.budget_in_cash = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
              สนับสนุนโดย<br>
              อุทยานวิทยาศาสตร์
            </div>

            <TextField
                theme="3"
                input-type="decimal"
                :value="tempBudget.budget_sci_park"
                @onChange="tempBudget.budget_sci_park = $event"
            ></TextField>
          </div>
        </div>

        <div>
          <div>
            <div class="black--text mb-3">
              รายละเอียด
            </div>

            <TextArea
                theme="3"
                :value="tempBudget.budget_detail"
                @onChange="tempBudget.budget_detail = $event"
            ></TextArea>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button
              min-width="80px"
              theme="2"
              @onClick="partTwoEditMode = false"
          >ยกเลิก
          </Button>

          <Button
              min-width="80px"
              theme="6"
              @onClick="saveBudget"
          >ยืนยัน
          </Button>
        </div>

      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              3. ตารางสรุปแผนการดําเนินงาน
              <span class="theme-color-seven txt-normal">(ข้อมูลจากข้อที่ 1)</span>
            </div>
<!--            <Button-->
<!--                theme="6"-->
<!--                :disabled="partThreeEditMode"-->
<!--                @onClick="addNewPlanDetail"-->
<!--            >-->
<!--              + เพิ่มรายละเอียดแผนงาน-->
<!--            </Button>-->
          </div>

          <!--   HEADERS   -->
          <div class="d-flex px-13 mb-5">
            <div class="flex" style="min-width: 230px; max-width: 230px">
              กิจกรรม
            </div>

            <div class="flex mx-3" style="min-width: 1px; max-width: 1px"></div>

            <div class="d-flex justify-space-between" style="width: 100%">
              <div
                  v-for="(m, ind) in shortMonths"
                  :key="ind"
                  class="flex"
                  style="min-width: 45px"
              >
                <div class="text-center">{{ m.month }}</div>
                <!--              <div class="text-center">65</div>-->
              </div>
            </div>
          </div>

          <!--   ITEMS   -->
          <div class="d-flex flex-column gap-16">
            <div
                v-for="(item, i) in allProgressPlan"
                :key="i"
                class="summary-plan"
            >
              <div class="d-flex black--text">
<!--                <div class="mr-2" style="min-width: 30px; max-width: 30px">-->
<!--                  <v-btn small icon @click="editProgressPlan(i)">-->
<!--                    <Iconify-->
<!--                        icon="material-symbols:edit"-->
<!--                        color="var(&#45;&#45;theme-color-seven)"-->
<!--                    ></Iconify>-->
<!--                  </v-btn>-->
<!--                </div>-->

                <div class="two-line" style="min-width: 230px; max-width: 230px">
                  {{ item.activity_name }}
                </div>

                <v-divider class="mx-3" vertical style="height: 54px"></v-divider>

                <div class="flex plan-slot d-flex pr-10">
                  <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex"
                      :class="{
                        'progress-plan-mark': item.plan.includes(m.key),
                        'start-point': Math.min.apply(null, item.plan) === m.key,
                        'end-point': Math.max.apply(null, item.plan) === m.key
                      }"
                  >
                    <v-divider v-if="item.plan.includes(m.key)"></v-divider>
                    <div
                        class="white--text arrow-right"
                    >&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div v-if="partThreeEditMode" class="card-part">
        <div class="d-flex gap-16 mb-3">
          <div>
            <div class="black--text mb-3">
              กิจกรรม
            </div>

            <TextField
                theme="3"
                :value="tempProgressPlan.p3_act_name"
                @onChange="tempProgressPlan.p3_act_name = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
              หมายเหตุ
            </div>

            <TextField
                theme="3"
                :value="tempProgressPlan.p3_remark"
                @onChange="tempProgressPlan.p3_remark = $event"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-space-between mb-5 px-6">
          <div
              v-for="(item, i) in shortMonths"
              :key="i"
          >
            <div class="black--text mb-1">{{ item.month }}</div>
            <CheckBox
                color="var(--theme-color-three)"
                :input-value="tempProgressPlan.plan.includes(item.key)"
                @onChange="progressPlanCheck(item.key)"
            ></CheckBox>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button
              min-width="80px"
              theme="2"
              @onClick="partThreeEditMode = false"
          >ยกเลิก
          </Button>

          <Button
              min-width="80px"
              theme="6"
              @onClick="saveProgressPlan"
          >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            4. รายละเอียดการส่งมอบงาน
            <span class="theme-color-seven txt-normal">(โปรดระบุจำนวนวันส่งรายงานความก้าวหน้าและรายงานฉบับสมบูรณ์ อ้างอิงจากกิจกรรมการดำเนินงาน)</span>
          </div>

          <div class="d-flex gap-12 txt-bigger black--text mb-3">
            <div class="flex xs4">แผนการส่งมอบ</div>
            <div class="flex xs2">จำนวนวัน</div>
            <div class="flex xs4">รายละเอียดงานที่ส่งมอบ</div>
            <div class="flex xs2">การเบิกจ่ายเงิน</div>
          </div>

          <div class="d-flex gap-12 mb-5">
            <div class="flex xs4">
              <ul>
                <li>ลงนามในสัญญา</li>
              </ul>
            </div>
            <div class="flex xs2">

            </div>
            <div class="flex xs4">
              <ul>
                <li>ลงแผนการดำเนินโครงการ</li>
              </ul>
            </div>
            <div class="flex xs2">
              <ul>
                <li>งวดที่ 1 (50%)</li>
              </ul>
            </div>
          </div>

          <div class="d-flex gap-12 mb-5">
            <div class="flex xs4">
              <ul>
                <li>
                  ส่งรายงานความก้าวหน้า จำนวน 1 ชุด พร้อมไฟล์
                </li>
              </ul>
            </div>
            <div class="flex xs2">
              <div class="black--text d-flex" style="align-items: center">
                <span class="mr-2">
                ภายใน
                </span>
                <TextField
                    theme="3"
                    input-type="number"
                    :value="project_section.s3_p4_progress_day"
                    @onChange="setFormField('s3_p4_progress_day', $event)"
                ></TextField>
              </div>
              <span class="theme-color-eight flex-1-1-100" style="margin-top: -10px">(นับจากวันที่ลงนามในสัญญา)</span>
            </div>
            <div class="flex xs4">
              <ul>
                <li>
                  <div class="mb-1 black--text">ผลการดำเนินงานตามข้อเสนอโครงการไม่น้อยกว่าร้อยละ 50</div>
                  <div class="d-flex" style="align-items: center">
                      <span class="mr-2">ตามข้อที่</span>

                    <TextField
                        theme="3"
                        :value="project_section.s3_p4_progress_pct"
                        @onChange="setFormField('s3_p4_progress_pct', $event)"
                    ></TextField>
                  </div>
                  <div>ในตารางสรุปแผน ดำเนินงาน</div>
                </li>
              </ul>
            </div>
            <div class="flex xs2">
              <ul>
                <li>งวดที่ 2 (30%)</li>
              </ul>
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex xs4">
              <ul>
                <li>
                  ส่งรายงานฉบับสมบูรณ์ จำนวน 1 ชุด พร้อมไฟล์
                </li>
              </ul>
            </div>
            <div class="flex xs2">
              <div class="black--text d-flex" style="align-items: center">
                <span class="mr-2">
                ภายใน
                </span>
                <TextField
                    theme="3"
                    input-type="number"
                    :value="project_section.s3_p4_final_day"
                    @onChange="setFormField('s3_p4_final_day', $event)"
                ></TextField>
              </div>
              <span class="theme-color-eight flex-1-1-100" style="margin-top: -10px">(นับจากวันที่ลงนามในสัญญา)</span>
            </div>
            <div class="flex xs4">
              <ul>
                <li>ผลการดำเนินงานตามข้อเสนอ โครงการที่เสร็จสมบูรณ์เรียบร้อย</li>
              </ul>
            </div>
            <div class="flex xs2">
              <ul>
                <li>งวดที่ 3 (20%)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">4. ปัญหาและอุปสรรคจากการดำเนินงาน</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
          <TextArea
              theme="3"
              height="100"
              :value="project_section.s3_problem"
              @onChange="setFormField('s3_problem', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">5. แนวทางในการแก้ไขปัญหา</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
          <TextArea
              theme="3"
              height="100"
              :value="project_section.s3_solution"
              @onChange="setFormField('s3_solution', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import TextArea from "../../../components/input/TextArea"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import Button from "../../../components/input/Button"
import CheckBox from "../../../components/input/CheckBox"
import { eventBus, formatNumber } from "../../../plugins/global-funcs"
import { mapState } from "vuex"
import { format } from 'date-fns'
import { th } from 'date-fns/locale'

export default {
  name: "CFormPlan",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    CheckBox,
    Button
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data() {
    return {
      formatNumber,
      form: {},
      tempPlan: {},
      tempBudget: {},
      tempProgressPlan: {},
      partOneEditMode: false,
      partTwoEditMode: false,
      partThreeEditMode: false,
      project_section: null,
      allPlans: [],
      shortMonths: [],
      plan_prototype: {
        p1_wf: '',
        project_section_plan_month: []
      },
      progressPlan_prototype: {
        plan: []
      },
      error_p1_wf: false,
      allProgressPlan: [
      ],
      allEventsName: [
          'ส่งเสริมคุณภาพการออกแบบและพัฒนา',
          'พัฒนาระบบด้านเทคโนโลยีของหุ่นยนต์'
      ],
      budgetList: [],
      fiscalYear: new Date().getFullYear() + 543
    }
  },
  computed: {
    ...mapState({
      PlanForm: state => state.CForm.PlanForm
    }),
    isFinal () {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  created() {
    this.clearTempPlan()
    this.clearTempProgressPlan()
    if (this.isSameId && !this.masterData.form_c) this.form = this.PlanForm
    if (this.masterData.form_c) {

      this.project_section = this.masterData.form_c.project_section
      this.allPlans = this.masterData.form_c.project_section_plan?.project_plan_p1 || []
      this.plotProgressPlanGraphData()
      for (const x of this.allPlans) {
        x.percent = this.getLastProgress(x.project_section_plan_month)
      }
      this.budgetList = this.masterData.form_c.project_section_plan?.project_section_budget || []
      this.fiscalYear = this.masterData.form_c.fiscal_year
    }

    // set begin budget year month
    this.setupBudgetYearMonth()

    eventBus.$on('cFormPlan', () => {
      eventBus.$emit('cFormPlanSend', {
        ...this.project_section,
        project_section_plan_p1: this.allPlans.map(x => ({
          ...x,
          percent: undefined
        })),
        project_section_budget: this.budgetList,
        budget_amount: this.formatNumber(this.budgetList.map(x => x.budget_sum).reduce((a, b) => a + b, 0), 2)
      })
    })

    eventBus.$on('cFormSummary', () => {
      this.$store.commit('CForm/addSummaryData', {
        shortMonths: this.shortMonths,
        partThreeForm: this.form,
        partThreeAllPlans: this.allPlans,
        partThreeBudgetList: this.budgetList,
        partThreeAllProgressPlan: this.allProgressPlan
      })
    })
  },
  methods: {
    setFormField(field, val) {
      this.project_section[field] = val
      this.$forceUpdate()
    },
    plotProgressPlanGraphData() {
      let allPG = [];
      if(this.allPlans.length > 0 ){
        this.allPlans.forEach((plan) => {
          let PG = {
            activity_name: plan.p1_activity_name,
            plan: []
          }
          if(plan.project_section_plan_month && plan.project_section_plan_month.length > 0){
            let month_plans = [];
            plan.project_section_plan_month.forEach((month, index) => {
              if(month.month_value !== null && parseInt(month.month_value) !== 100)
                month_plans.push(index+1)
            })
            PG.plan = month_plans
          }
          allPG.push(PG)
        })
      }

      console.log('allPG', allPG)
      this.allProgressPlan = allPG;
    },
    addNewPlan() {
      // clear temp index
      this.clearTempPlan()
      if (this.partOneEditMode) {
        this.$vuetify.goTo('#part-one-edit')
      } else {
        this.tempPlan.isNew = true
        this.partOneEditMode = true
      }
    },
    editPlan(i) {
      this.partOneEditMode = false
      this.tempPlan = {
        ...this.removeVModel(this.allPlans[i]),
        temp_index: i
      }
      this.partOneEditMode = true
      this.$forceUpdate()
    },
    savePlan() {
      // complete 2 pos decimal format
      this.completeTwoPosDecimal()

      // validate WF
      if (!this.validateWF()) return;

      // validate conditions
      let before_value = 0
      let error = []
      for (const x of this.tempPlan.project_section_plan_month) {
        if (!isNaN(x.month_value) && (parseFloat(x.month_value) < before_value)) {
          x.error = true
          error.push('Value must be greater than previous month value')
        } else {
          x.error = undefined
          if (x.errorSkipInput) {
            error.push('Cannot skip the input between input values')
          }
        }
        before_value = parseFloat(x.month_value)
      }
      this.$forceUpdate()
      if (error.length > 0) {
        console.log(error)
        return
      }

      let lastProgress = this.getLastProgress(this.tempPlan.project_section_plan_month)
      if (!this.tempPlan.isNew) {
        // EDIT
        this.allPlans[this.tempPlan.temp_index] = {
          ...this.tempPlan,
          percent: lastProgress,
          temp_index: undefined
        }
      } else {
        // ADD
        this.allPlans.push({
          p1_activity_name: this.tempPlan.p1_actvity_name,
          p1_wf: this.tempPlan.p1_wf,
          project_section_plan_month: this.tempPlan.project_section_plan_month,
          percent: lastProgress
        })
      }

      this.plotProgressPlanGraphData()
      this.clearTempPlan()
      this.partOneEditMode = false
    },
    clearTempPlan() {
      this.tempPlan = this.removeVModel(this.plan_prototype)
      this.error_p1_wf = false
      this.$forceUpdate()
    },
    removeVModel (item) {
      return JSON.parse(JSON.stringify(item))
    },
    getLastProgress (items) {
      items = this.removeVModel(items)
      if (items && typeof items === 'object' && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== '-') {
            return x.month_value
          }
        }
      }
      return '-'
    },
    completeTwoPosDecimal () {
      let i = 0
      for (const x of this.tempPlan.project_section_plan_month) {
        x.errorSkipInput = undefined
        if (!x.month_value || isNaN(x.month_value)) {
          x.month_value = null
          if (i > 0) {
            let hasSomeProgressBefore = false
            let hasSkipInput = false
            for (let ind = 0; ind < i; ind++) {
              if (this.tempPlan.project_section_plan_month[ind].month_value) {
                hasSomeProgressBefore = true
                for (let lastInd = this.tempPlan.project_section_plan_month.length - 1; lastInd > i; lastInd--) {
                  if (!!this.tempPlan.project_section_plan_month[lastInd].month_value) hasSkipInput = true
                }
              }
            }

            if (hasSomeProgressBefore) x.month_value = '100.00'
            if (hasSkipInput) {
              x.month_value = null
              x.errorSkipInput = true
            }
          }
        } else {
          // no decimal case
          if (!x.month_value.toString().includes('.')) {
            x.month_value += '.00'
          } else {
            // decimal case
            let y = x.month_value.toString().split('.')
            if (!y[0] && y[0] != '0') {
              y[0] = '0'
            }
            if (!y[1] && y[1] != '0') {
              y[1] = '00'
            }
            // fill zero for 2 position decimal
            if (y.length > 1 && y[1].length === 1) {
              y[1] = y[1].toString() + '0' // add 0 as string
            }
            // remove after 2 position decimal
            if (y.length > 1 && y[1].length > 2) {
              y[1] = y[1].substring(0, 2)
            }
            x.month_value = y[0] + '.' + y[1]
            if (x.month_value === '0.00') x.month_value = null
          }
        }
        i++
      }
    },
    validateWF () {
      let error = []
      let total = 0
      let editCase = !!this.tempPlan.temp_index || this.tempPlan.temp_index === 0

      // total is 1.00
      if (this.allPlans.length > 0) {
        if (this.allPlans.length === 1) {
          total = this.allPlans[0].p1_wf
          if (editCase) total = 0
        } else {
          if (editCase) {
            total = this.allPlans.filter((x, i) => i !== this.tempPlan.temp_index).map(x => x.p1_wf).reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
          } else {
            total = this.allPlans.reduce((a, b) => parseFloat(a.p1_wf) + parseFloat(b.p1_wf), 0)
          }
        }

        if (parseFloat(total) >= 1) {
          error.push('WF value cannot over exceed 1.00')
        }
      }

      if (!this.tempPlan.p1_wf || isNaN(this.tempPlan.p1_wf)) {
        error.push('WF value is not correct')
      } else {
        // no decimal case
        if (!this.tempPlan.p1_wf.toString().includes('.')) {
          this.tempPlan.p1_wf += '.00'
        } else {
          // decimal case
          let y = this.tempPlan.p1_wf.toString().split('.')
          if (!y[0] && y[0] != '0') {
            y[0] = '0'
          }
          if (!y[1] && y[1] != '0') {
            y[1] = '00'
          }
          // fill zero for 2 position decimal
          if (y.length > 1 && y[1].length === 1) {
            y[1] = y[1].toString() + '0' // add 0 as string
          }
          // remove after 2 position decimal
          if (y.length > 1 && y[1].length > 2) {
            y[1] = y[1].substring(0, 2)
          }
          this.tempPlan.p1_wf = y[0] + '.' + y[1]
          if (this.tempPlan.p1_wf === '0.00') {
            error.push('WF value is not correct')
          }
        }
        if (this.tempPlan.p1_wf > 1) {
          error.push('WF value must less or equal 1.00')
        }
      }

      if (parseFloat(total) + parseFloat(this.tempPlan.p1_wf) > 1) {
        error.push('WF total value must equal 1.00')
      }

      if (error.length > 0) {
        console.log(error)
        this.error_p1_wf = true
      } else {
        this.error_p1_wf = false
      }
      this.$forceUpdate()

      return !this.error_p1_wf

    },
    totalWF () {
      if (!this.allPlans || this.allPlans.length === 0) return '-'
      let total = this.allPlans.map(x => x.p1_wf).reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      if (typeof total === 'number') return total.toFixed(2)
      return total
    },
    weightPlan (index) {
      let total = []
      for (const x of this.allPlans) {
        let result = x.project_section_plan_month[index] ? parseFloat(x.project_section_plan_month[index].month_value * x.p1_wf) : 0
        if (!isNaN(result)) {
          total.push(result)
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0)
      } else {
        total = '-'
      }
      if (typeof total === 'number') return total.toFixed(2)
      return total
    },
    addNewBudget () {
      if (this.partTwoEditMode) {
        // clear temp index
        // this.clearTempPlan()

        this.$vuetify.goTo('#part-two-edit')
      } else {
        // this.tempPlan.isNew = true
        this.partTwoEditMode = true
      }
    },
    saveBudget () {
      this.partTwoEditMode = false
      this.tempBudget.budget_sum = parseFloat(this.tempBudget.budget_in_kind) + parseFloat(this.tempBudget.budget_in_cash) + parseFloat(this.tempBudget.budget_sci_park)
      this.budgetList.push(this.tempBudget)
      this.tempBudget = {}
    },
    addNewPlanDetail () {
      this.clearTempProgressPlan()
      this.partThreeEditMode = true
    },
    saveProgressPlan () {
      let error = []
      if (this.tempProgressPlan.plan.length === 0) {
        error.push('Select at least 1 month for planning')
        return
      }
      if (this.tempProgressPlan.temp_index !== undefined) {
        // EDIT
        this.allProgressPlan[this.tempProgressPlan.temp_index] = {
          ...this.tempProgressPlan,
          temp_index: undefined
        }
      } else {
        // ADD
        this.allProgressPlan.push(this.tempProgressPlan)
      }
      this.clearTempProgressPlan()
      this.partThreeEditMode = false
    },
    progressPlanCheck (key) {
      if (this.tempProgressPlan.plan.includes(key)) {
        this.tempProgressPlan.plan = this.tempProgressPlan.plan.filter(x => x !== key)
      } else {
        this.tempProgressPlan.plan.push(key)
      }
    },
    clearTempProgressPlan () {
      this.tempProgressPlan = this.removeVModel(this.progressPlan_prototype)
      this.$forceUpdate()
    },
    editProgressPlan (index) {
      this.partThreeEditMode = false
      this.tempProgressPlan = {
        ...this.removeVModel(this.allProgressPlan[index]),
        temp_index: index
      }
      this.partThreeEditMode = true
      this.$forceUpdate()
    },
    setupBudgetYearMonth () {
      let ym = new Date((this.fiscalYear - 543).toString() + '-10')
      for (let i = 0; i < 12; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, 'MMM', { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split('-')[0]) + 543).toString().slice(2)
        })
        this.plan_prototype.project_section_plan_month.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: ''
        })
        ym = new Date(ym.setMonth(ym.getMonth() + 1))
      }
    }
  }
}
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #FFFFFF;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #FAFAFA;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #FFFFFF;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}


.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr));
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: 'Tahoma', sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}

</style>